module.exports = __webpack_public_path__ + "static/media/main-bg.83bd0054.jpg";